<template>
  <DsButton variant="bordered" theme="dark" shape="pill" size="56" class="w-full" @click="navigate">
    <span class="flex items-center gap-[10px]">
      <img
        src="/assets/icons/service-highlights/watch-service-replay.svg"
        class="h-[16px] w-[16px]"
        alt=""
      />
      Watch Service Replay
    </span>
  </DsButton>
</template>

<script>
import { mapGetters } from 'vuex';
import { Button as DsButton } from '@team-hogc/hogc-one-design-system';
import { trackServiceReplaySelected } from '@/utils/analytics';

export default {
  components: {
    DsButton,
  },
  computed: {
    ...mapGetters('serviceHighlights', ['currentService']),
  },
  methods: {
    navigate() {
      trackServiceReplaySelected({
        replayId: this.currentService.serviceReplayId,
        title: this.currentService.title || this.currentService.name,
        selectionType: 'watch-button',
        source: 'service-highlights',
      });
      this.$router.push('/service-replay');
    },
  },
};
</script>
